<ion-modal class="app-modal app-prompt-modal" #modal [backdropDismiss]="backdropDismiss" [isOpen]="open" (didDismiss)="onCancel()">
  <ng-template>
      <ion-content>
        <ion-text>
          <h1 class="title">{{title}}</h1>
        </ion-text>
        <ion-text>
          <p *ngIf="message">{{message}}</p>
          <p *ngIf="!message">
            <ng-content></ng-content>
          </p>
        </ion-text>
      </ion-content>
      <ion-footer>
        <ion-button mode="md" fill="clear" [color]="!invert ? 'danger' : 'secondary'" (click)="onCancel()">Cancel</ion-button>
        <ion-button mode="md" [color]="invert ? 'danger' : 'secondary'" (click)="onConfirm()">{{confirmLabel}}</ion-button>
      </ion-footer>
  </ng-template>
</ion-modal>